export default "__VITE_ASSET__GMgQQXbu__"